/**
 *
 * image - log con imagen
 * text - log de texto simple
 * message - log de envío de notificaciones
 * damageMoved - log de movimiento de daño
 * list - log de listados
 * detailed - log con texto y detalle
 * concept - log de concepto nuevo
 */
export var LogTypeEnum;
(function (LogTypeEnum) {
    LogTypeEnum["image"] = "image";
    LogTypeEnum["text"] = "text";
    LogTypeEnum["message"] = "message";
    LogTypeEnum["damageMoved"] = "damageMoved";
    LogTypeEnum["damageUpdated"] = "damageUpdated";
    LogTypeEnum["list"] = "list";
    LogTypeEnum["detailed"] = "detailed";
    LogTypeEnum["concept"] = "concept";
    LogTypeEnum["blocked"] = "blocked";
    LogTypeEnum["damageChanged"] = "damageChanged";
    LogTypeEnum["paintSystemUpdated"] = "paintSystemUpdated";
})(LogTypeEnum || (LogTypeEnum = {}));
